import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import planner from "./planner";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    planner,
  },
});
